import React, { useState, useEffect, useContext } from "react"
import {getProblems, sendMessage, generativeModelResponse, changePage} from "../../../../functions/api"
import {CategoriesContext, LawyerContext, LoadingContext} from '../../../../partials/Context';
import {AIWarningTooltip, RaspTooltip} from '../../../../partials/Partials';

import Header from './Header';
import FilterBoard from "./filter_board/FilterBoard";
import ProblemContent from "./problem_content/ProblemContent";
import SwitchProblem from "./SwitchProblem";
import RespondedAmount from "./RespondedAmount";

function Dashboard() {
    const [problems, setProblems] = useState({})
    const [chosen_categories, setChosenCategories] = useState([]);
    const [filter_open, setFilter] = useState(false);
    const [api_categories, setApiCategories] = useState('');
    const [index_counter, setIndexCounter] = useState(1);
    const [current_page, setCurrentPage] = useState(1);
    const [if_limit, setLimit] = useState(true);
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState([]);
    const [responded_problems_count, setResponded] = useState();
    const {count, results} = problems;
    const lawyer = useContext(LawyerContext);
    const categories = useContext(CategoriesContext);
    const {prywatne, firmowe} = categories || [];
    const {is_non_test_premium} = lawyer;
    let problem_index = [index_counter-1]%5;

    const {loading, setLoading} = useContext(LoadingContext);

    useEffect(()=>{
        setResponded(lawyer.responded_problems_count)
    },[lawyer])

    useEffect(()=> {
        if(prywatne && firmowe) {
            setLoading(true)
            let local_categories=[];
            prywatne.map(item=>{
                return local_categories.push(item.slug);
            })
            firmowe.map(item=>{
                return local_categories.push(item.slug);
            })
            let api_categories = local_categories.join('+');
            setApiCategories(api_categories);
            getProblems(setProblems, api_categories, current_page, setLoading, setErrors)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categories])

    useEffect(()=> {
        setLoading(true)
        getProblems(setProblems, api_categories, current_page, setLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [api_categories, responded_problems_count]);

    const handleSubmitFilter = (chosen_categories) => {
        setFilter(false)
        setChosenCategories(chosen_categories)
            let local_categories = [];
            chosen_categories.map(item => {
                local_categories.push(item)
                return local_categories
            })
            let api_categories = local_categories.join('+');
            setApiCategories(api_categories)
            setCurrentPage(1)
            setIndexCounter(1);
    }

    const handleFilter = () => {
        let filter = filter_open;
        setFilter(!filter)
    }

    const setHeight = (elementId, height) => {
        let element = document.getElementById(`${elementId}`);
        if (element === null || element === undefined) {
            return;
        }
        element.style.height = height;
    }

    const handleNext = () => {
        if(!loading && index_counter < problems.count) {
            setLimit(true);
            setMessage('');
            setHeight('responseMsgInput', '48px');
            if (problems.results[problem_index+1] !== undefined) {
                setIndexCounter(prevCount => prevCount+1)
            } else {
                setLoading(true)
                changePage(setProblems, api_categories, current_page, setLoading, setIndexCounter, setCurrentPage, 'next', setErrors)
            }
            setErrors([]);
        } 
    }

    const handlePrevious = () => {
        if (!loading && problem_index >= 0) {
            setLimit(true);
            setMessage('');
            setHeight('responseMsgInput', '48px');
            if(problem_index > 0) {
                setIndexCounter(prevCount => prevCount-1)
            } else if (problem_index === 0 && current_page !== 1) {
                setLoading(true)
                changePage(setProblems, api_categories, current_page, setLoading, setIndexCounter, setCurrentPage, 'prev', setErrors);
            }
            setErrors([]);
        }
    }   

    const showMore = (e) => {
        setLimit(false)
        e.preventDefault();
    }

    const handleMessageChange = (event) => {
        setMessage(event.target.value)
    }

    const submitResponse = (event) => {
        setLoading(true)
        event.preventDefault();
        let problem_id = problems.results[problem_index].id;
        sendMessage(message, problem_id, setErrors, setProblems, api_categories, current_page, setLoading, index_counter, setIndexCounter, problems.count, setCurrentPage);
        setLimit(true);
        setMessage('');
        setResponded(prevCount => prevCount+1)
        event.target.querySelector('textarea').style.height = '48px';
    }

    const getResponse = (e) => {
        setLoading(true);
        let problem_id = problems.results[problem_index].id;
        generativeModelResponse(problem_id, 'responseMsgInput', setLoading);
    };

    let rasp = false;
    if (results !== undefined && results[problem_index] !== undefined) {
        rasp = results[problem_index].rasp;
    }

    return (
        <div className="dashboard">
            <Header
                problems_count={count}
                rasp={rasp}
                handleFilter={handleFilter}
            />
            <FilterBoard
                prywatne={categories.prywatne}
                firmowe={categories.firmowe}
                filter_open={filter_open}
                current_categories={chosen_categories}
                handleSubmitFilter={handleSubmitFilter}
            />
            <ProblemContent
                problems={problems}
                problem_index={problem_index}
                limit={if_limit}
                showMore={showMore}
                message={message}
                handleChange={handleMessageChange}
                submitResponse={submitResponse}
                getResponse={getResponse}
                errors={errors}
                loading={loading}
                page={current_page}
                index_counter={index_counter}
                responded_problems_count={responded_problems_count}
            />
            <AIWarningTooltip
                is_non_test_premium={is_non_test_premium}
            />
            <RaspTooltip
                rasp={rasp}
            />
            <SwitchProblem
                problems_count={problems.count}
                index_counter={index_counter}
                onNext={handleNext}
                onPrevious={handlePrevious}
            />
            <RespondedAmount
                responded_count={responded_problems_count}
            />
        </div>
    )
}

export default Dashboard;